import React, { Component } from "react";
import _ from "lodash";
import "index.css";

import Container from "@material-ui/core/Container";
import Pagination from "@material-ui/lab/Pagination";
import Typography from "@material-ui/core/Typography";
import CartoucheSeance from "components/CartoucheSeance";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withTranslation } from "react-i18next";
import Context from 'utils/Context';

class MesSeances extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myShows: [],
            noShow: false,
            page: 1,
            itemsParPage: 4,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }
    handlePageChange(event, value) {
        this.setState({ page: value });
    };
    render() {
        const { t } = this.props;
        const { appState, goTo } = this.context;
        const { itemsParPage, page } = this.state;
        let seancesAVenir = _.filter(appState.user.mes_seances, (s) => !s.ended);
        let seancesPassees = _.filter(appState.user.mes_seances, (s) => s.ended);
        let selectionPassees = _.filter(seancesPassees, (s, i) =>
            i >= (page - 1) * itemsParPage
            && i < (page) * itemsParPage
        )
        let nbPages = Math.ceil((seancesPassees.length - 1) / itemsParPage);

        return (
            <Paper>
                <Container>
                    <div className="spacer" />
                    {seancesAVenir.length > 0 && (
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h4">
                                    {t('a-venir')}
                                </Typography>
                            </Grid>
                            {seancesAVenir.map((s) => (
                                <Grid item xs={12} md={6} key={s.seance_id}>
                                    <CartoucheSeance showAccess={true} goTo={goTo} appState={appState} seance={s} key={s.seance_id}  {...this.props} />
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    {seancesAVenir.length > 0 && selectionPassees.length > 0 && (
                        <Grid item xs={12}>
                            <div className="spacer" />
                            <div className="spacer" />
                        </Grid>
                    )}
                    {selectionPassees.length > 0 && (
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h4">{t('passees')}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Pagination
                                    count={nbPages}
                                    page={page}
                                    onChange={this.handlePageChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <p className="page-infos">
                                    {(page - 1) * itemsParPage + 1} - {Math.min(seancesPassees.length, (page) * itemsParPage)} de {seancesPassees.length}
                                </p>
                            </Grid>
                            {selectionPassees.map((s) => (
                                <Grid item xs={12} md={6} key={s.seance_id}>
                                    <CartoucheSeance
                                        showAccess={true}
                                        goTo={goTo}
                                        appState={appState}
                                        seance={s}
                                        key={s.seance_id}
                                        {...this.props}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    {appState.user.mes_seances && appState.user.mes_seances.length === 0 && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <p>{t('aucune-seance')}</p>
                            </Grid>
                        </Grid>
                    )}
                </Container>
            </Paper>
        );
    }
}

MesSeances.contextType = Context;

export default withTranslation()(MesSeances);
